// import config from 'common-module/src/config';
import { commonCacheLanguage } from 'common-module/src/lang';
import store from '@/store';
// import { isOverseasVersion } from 'common-module/src/util';
import ws from '@/utils/ws';
import { safeParse } from '@/utils';
import { isProd, systemUpdateKey, isPre } from '@/utils/const';

import { reloadI18n } from 'common-module/src/util/index';
import { queryCurrentVersion } from '@/api/versions';
import { isNil } from 'lodash';

const popoverVersionInfo = {
  version: 0, // 版本信息
  showTime: 0 // 弹层渲染时间
};

const REFRESH_I18N = '1'; //刷新国际化
export class version {
  constructor() {}
  init() {
    // store.dispatch('app/getCurrentVersion');
    this.checkVersion();
    window.addEventListener('online', this.checkVersion);
    document.addEventListener('visibilitychange', this.handleVisible);
    // store.commit('app/SET_CURRENT_VERSION', window.$config.VUE_APP_VERSION);
    ws.on('global:op_ws_version', this.handleMsg);
  }

  handleVisible = () => {
    if (document.hidden === true) {
      return;
    }
    this.checkVersion();
  }
  handleMsg = (msg) => {
    console.log('----推送接收到消息', msg);
    if (msg?.action !== 'opWsVersion') {
      return;
    }
    const result = msg?.result || {};
    this.handleAction(result);
  };
  handleAction(result){
    // if (isOverseasVersion) {
    //   return;
    // }
    console.log('----版本信息--', result);
    const totalVersion = +result.totalVersion;
    if (totalVersion <= store.state.app.currentVersion) {
      return;
    }
    if (!isProd && !isPre) {
      localStorage.setItem(systemUpdateKey, +result.totalVersion);
      // localStorage.removeItem(systemUpdateKey);
    }
    if (result.updateType === 2) {
      store.commit('app/SET_VERSION_UPDATE_INFO', {
        ...result,
        show: true
      });
      popoverVersionInfo.version = +result.totalVersion;
      popoverVersionInfo.showTime = +new Date();
    }

    const updateActions = safeParse(result?.updateActions);
    if (!updateActions) {
      return;
    }
    if (updateActions[REFRESH_I18N]) {
      this.resetI18n();
    }
  }
  // 更新国际化
  async resetI18n() {
    const locale = store.state.user.org?.language?.includes('en') ? 'us' : 'cn';
    await reloadI18n(locale);
    commonCacheLanguage.loadLanguages(undefined, true);
  }
  showModel() {}
  checkVersion = async () => {
    // store.dispatch('app/getCurrentVersion');
    let versions = await queryCurrentVersion({ totalVersion: store.state.app.currentVersion || 0 });
    versions = Array.isArray(versions) ? versions.filter(i => +i.totalVersion !== +store.state.app.currentVersion) : [versions];
    const assembleInfo = versions.reduce((res, item) => {
      const actions = JSON.parse(item.updateActions) || {};
      res.updateActions = Object.assign(res.updateActions || {}, actions);
      res.totalVersion = Math.max(res.totalVersion || 0, item.totalVersion);
      res.updateType = res.updateType === 2 ? 2 : item.updateType; // 更新类型： 1、静默更新， 2、弹窗更新
      //0519运营后台加ab开关判断用户是否更新
      res.isUpdate = res.isUpdate ? res.isUpdate : (item.flagKey ? item.isShow : true);
      return res;
    }, {});
    if (!assembleInfo.isUpdate) {
      //0519运营后台加ab开关判断用户是否更新
      return;
    }
    const onlyRefreshI18n = Object.keys(assembleInfo.updateActions || {}).every(i => +i === 1);
    if (onlyRefreshI18n && assembleInfo.updateType === 1 || isNil(assembleInfo.updateType)) {
      return;
    }
    const showModelDuration = window.$config.showModelDuration || 1000 * 60 * 30; // 推送弹窗显示间隔时间
    const isOften = +new Date() - popoverVersionInfo.showTime < showModelDuration;
    // 提示太频繁，不做处理
    if (isOften && popoverVersionInfo.version === assembleInfo.totalVersion) {
      return;
    }

    this.handleAction(assembleInfo);
  };
  destroy() {
    window.removeEventListener('online', this.checkVersion);
    document.removeEventListener('visibilitychange', this.handleVisible);
  }
}
const instance = new version();
export default instance;
